import MuiInput from '@mui/material/Input';
import MuiInputLabel from '@mui/material/InputLabel';
import MuiInputAdornment from '@mui/material/InputAdornment';
import styledMmmField from './styledMmmField';

export const Input = styledMmmField(MuiInput);
export const InputLabel = styledMmmField(MuiInputLabel);
export const InputAdornment = styledMmmField(MuiInputAdornment);
